import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { InputNumber, Form, Input, Select } from 'antd';


import CRUDE_KakVichislitAkkaunt from '../../../objects/KakVichislitAkkaunt/crude'
import REDUX_KakVichislitAkkaunt from '../../../objects/KakVichislitAkkaunt/reducer'

import { GET, queryFilterByItem, errorCatch } from 'fennec-ui'
import InputWithSearchModal from '../../components/InputWithSearchModal';
import AkkauntFilter from '../AkkauntFilter';
import AkkauntSelector from '../AkkauntSelector';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');


const { Option } = Select; 

export default function NovayaKomissiiPartneram(props) {
    const { auth, object, form, sourceKey, queryFilterContext, soruceID } = props;
    const dispatch = useDispatch();
    const kakVichislitAkkaunt = useSelector(REDUX_KakVichislitAkkaunt.selector.array);
    
    const [promokodi, setPromokodi] = useState([])
    useEffect(() => {
        form.resetFields();
        CRUDE_KakVichislitAkkaunt.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_KakVichislitAkkaunt.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');

        let postfix = "";
        if (sourceKey === "admin") {
            postfix = `/${soruceID}`
        }

        GET(auth, "/api/promokodi/list/"+sourceKey + postfix + ((queryFilterContext)?"?detail=model&" + queryFilterByItem(queryFilterContext):""),
            ({data}) => {
                setPromokodi(data)
            },
            (err)=>errorCatch(err));
    }, []);
    const kakVichislitAkkauntOptions = kakVichislitAkkaunt.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    // const promokodiOptions = promokodi.map((i) => <Option key={i.ID} value={i.ID}>{i.promokod + " " + i.opisanie}</Option>);
    const promokodiOptions = promokodi.map((i) => {
        let desc = "";
        if (i?.organizatorFederatsiya) {
            desc = "Федерация"
        } else if (i?.organizatorRegionalnoeOtdelenie) {
            desc = "" + i?.organizatorRegionalnoeOtdelenie?.nazvanie
        } else if (i?.organizatorShkola) {
            desc = "" + i?.organizatorShkola?.nazvanieShkoliTantsev
        } else if (i?.organizatorMeropriyatiya) {
            desc = "" + i?.organizatorMeropriyatiya?.nazvanie
        }

        if (i?.meropriyatie) {
            desc += ", " + `${i?.meropriyatie?.nazvanieMeropriyatiya} - ${dayjs(i?.meropriyatie?.nachaloSorevnovaniya).format("DD.MM.YYYY")} ${(i?.meropriyatie?.mestoProvedeniya) ? "(" + i?.meropriyatie?.mestoProvedeniya?.name + ")" : ""}`
        }
        return (<Option key={i.ID} value={i.ID} label={i.promokod + " " + i.opisanie}>
            <div><span>{i.promokod}</span> <span style={{fontWeight:"lighter"}}>{i.opisanie}</span></div>
            {desc && <div style={{ fontSize: "12px", fontWeight: "lighter" }}>{desc}</div>}
        </Option>)
    });
    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item label="Суть комиссии"
                    name="sutKomissii"
                    rules={[{ required: true, message: 'Пожалуйста, укажите суть комиссии!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Промокод"
                    name="promokodID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите промокод!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase())
                        }
                    >
                        {promokodiOptions}
                    </Select>
                </Form.Item>
                <Form.Item
                    name={"akkaunt"}
                    label={"Счет"}
                    rules={[{ required: false, message: 'Укажите счет!' }]}
                >
                    <InputWithSearchModal auth={auth} title={"Поиск счета"} url={"/api/akkaunti/searchaccountbynumber"} 
                        errorTitle={"Счет не найден"} 
                        valueAsObject={true}
                        object={{ }}
                        display={(object)=>{
                            let res = object.nomerAkkaunta + " ";
 
                            if(object.akkauntiFedAkkaunt&&object.akkauntiFedAkkaunt.length>0) {
                                res += "Счет федерации социальных танцев";
                            } else if(object.akkauntiPolzovateleiAkkaunt&&object.akkauntiPolzovateleiAkkaunt.length>0) {
                                res += object.akkauntiPolzovateleiAkkaunt.map(e=> {
                                    return e.polzovatel.lastname + " " + e.polzovatel.firstname;
                                }).join(" ");
                            } else if(object.akkauntiRegionalnikhOtdeleniiAkkaunt&&object.akkauntiRegionalnikhOtdeleniiAkkaunt.length>0) {
                                res += object.akkauntiRegionalnikhOtdeleniiAkkaunt.map(e=> {
                                    return e.regionalnoOtdelenie.nazvanie;
                                }).join(" ");
                            } else if(object.akkauntiOrganizatorovAkkaunt&&object.akkauntiOrganizatorovAkkaunt.length>0) {
                                res += "Организатор: " + object.akkauntiOrganizatorovAkkaunt.map(e=> {
                                    return e.organizator.nazvanie;
                                }).join(" ");
                            } else if(object.akkauntiShkolAkkaunt&&object.akkauntiShkolAkkaunt.length>0) {
                                res += "Школа: " + object.akkauntiShkolAkkaunt.map(e=> {
                                    return e.shkola.nazvanieShkoliTantsev;
                                }).join(" ");
                            }
                            return res;
                        }}
                        searchForm={AkkauntFilter}
                        selectForm={AkkauntSelector} />
                </Form.Item>
                <Form.Item label="Как вычислить счет"
                    name="kakVichislitAkkauntID"
                    rules={[{ required: false, message: 'Пожалуйста, укажите как вычислить счет!' }]}
                >
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                        filterSort={(optionA, optionB) =>
                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                    >
                        {kakVichislitAkkauntOptions}
                    </Select>
                </Form.Item>
                <Form.Item label="Процент"
                    name="protsentKomissii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите процент!' }]}
                >
                    <InputNumber style={{width: "100%"}} step={1} />
                </Form.Item>
                <Form.Item label="Сумма"
                    name="summaKomissiii"
                    rules={[{ required: false, message: 'Пожалуйста, укажите сумму!' }]}
                >
                    <InputNumber style={{width: "100%"}} step={1} />
                </Form.Item>
            </Form>
        </>
    );
}
